import React from "react";

import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../DeshBoardFooter";
import { useParams } from "react-router-dom";
import LeadTransactionDetailsDataTable from "./LeadTransactionDetailsDataTable";
import { useAuth } from "../../../Store/AuthContext";

export default function LeadTransactionDetails() {
  const { RendomTokenfetch } = useAuth();
  let { leadid } = useParams();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Service Booking", pagelink: "service-booking" },
            {
              name: `Lead Transaction Details ${leadid}`,
            },
          ]}
        />

        <section className="user-dashboard">
          <div className="dashboard-outer">
            {/* ************Data Table Rows ************* */}
            {RendomTokenfetch && (
              <LeadTransactionDetailsDataTable leadid={leadid} />
            )}
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
